import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "Layout";
import Button from "@material-ui/core/Button";
import SpeakerNotesOff from "@material-ui/icons/VoiceOverOff";
import FilterList from "@material-ui/icons/FilterList";
import { Link } from "react-router-dom";
import useAuth from "Hooks/useAuth";
import googleAnalytics from "fuction/googleAnalytics";

const useStyles = makeStyles(() => ({
  menueText: {
    fontSize: "16px",
  },
}));

export default function Setting(props) {
  const { state } = useAuth();
  const classes = useStyles();

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 投稿分類管理メニュー";
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, state.user.account_id);
  }, [props.location.pathname]);

  return (
    <Layout
      content={
        <Grid className={classes.menueText}>
          {state.user.admin && (
            <>
              <Grid item>
                <Link to="/config/dictionarysetting/noise">
                  <Button  className={classes.menueText} startIcon={<SpeakerNotesOff />} href="/config/dictionarysetting/noise">
                    ノイズ辞書設定
                  </Button>
                </Link>
              </Grid>
              <Grid item>
                <Link to="/config/dictionarysetting/classification">
                  <Button  className={classes.menueText} startIcon={<FilterList />} href="/config/dictionarysetting/classification">
                    分類辞書設定
                  </Button>
                </Link>
              </Grid>
            </>
          )}
        </Grid>
      }
    />
  );
}
